import React from "react";
import { LANGS, useI18n } from "../../i18n/I18nProvider";

const LanguageSwitcher = () => {
  const { lang, setLang, t } = useI18n();

  return (
    <div
      role="group"
      aria-label={t("nav.language")}
      className="inline-flex items-center gap-0.5 rounded-pill bg-canvas p-0.5"
    >
      {LANGS.map((item) => {
        const active = item.code === lang;
        return (
          <button
            key={item.code}
            type="button"
            onClick={() => setLang(item.code)}
            aria-pressed={active}
            className={`min-h-11 min-w-11 rounded-[16px] px-2 text-caption font-medium tracking-[0.4px] focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-accent ${
              active
                ? "bg-paper font-semibold text-ink shadow-card"
                : "bg-transparent text-mid-gray"
            }`}
          >
            {item.short}
          </button>
        );
      })}
    </div>
  );
};

export default LanguageSwitcher;
